import { styled, ButtonBase, Badge, badgeClasses } from '@mui/material';

import ComminSoonChip from '../../../ComminSoonBadge';

export const IntegrationsSectionStoresCardBadge = styled(Badge)(
  ({ theme }) => ({
    [`& .${badgeClasses.badge}:not(.${badgeClasses.invisible})`]: {
      transform: `scale(1) translate(${theme.spacing(2.25)},-50%)`,
    },
  }),
);

export const IntegrationsSectionStoresCardCommingSoonChip = styled(
  ComminSoonChip,
)(({ theme }) => ({
  marginLeft: 0,
  backgroundColor: theme.palette.common.white,
}));

export const IntegrationsSectionStoresCardButton = styled(ButtonBase)(
  ({ theme, disabled }) => ({
    padding: theme.spacing(1, 2),
    borderRadius: theme.shape.borderRadius,
    border: `1px solid ${theme.palette.divider}`,

    ...(disabled && {
      backgroundColor: theme.palette.action.disabledBackground,
      opacity: theme.palette.action.disabledOpacity,
    }),
  }),
);

export const IntegrationsSectionStoresCardLogo = styled('img')({
  width: 150,
  mixBlendMode: 'multiply',
});
